import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path
      d="M14.646 9.85398C14.518 9.85398 14.39 9.80498 14.292 9.70798C14.097 9.51298 14.097 9.19598 14.292 9.00098L18.835 4.45898H16.5C16.224 4.45898 16 4.23498 16 3.95898C16 3.68298 16.224 3.45898 16.5 3.45898H20.042C20.244 3.45898 20.427 3.58098 20.504 3.76798C20.581 3.95498 20.538 4.16998 20.396 4.31298L15 9.70898C14.901 9.80498 14.773 9.85398 14.646 9.85398Z"
      fill="currentColor"
    />
    <path
      d="M20.042 8.50001C19.766 8.50001 19.542 8.27601 19.542 8.00001V3.95801C19.542 3.68201 19.766 3.45801 20.042 3.45801C20.318 3.45801 20.542 3.68201 20.542 3.95801V8.00001C20.542 8.27601 20.318 8.50001 20.042 8.50001Z"
      fill="currentColor"
    />
    <path
      d="M7.16696 20.875H3.62496C3.42296 20.875 3.23996 20.753 3.16296 20.566C3.08496 20.379 3.12796 20.164 3.27096 20.021L8.66696 14.625C8.86196 14.43 9.17896 14.43 9.37396 14.625C9.56896 14.82 9.56896 15.137 9.37396 15.332L4.83196 19.874H7.16596C7.44196 19.874 7.66596 20.098 7.66596 20.374C7.66596 20.65 7.44296 20.875 7.16696 20.875V20.875Z"
      fill="currentColor"
    />
    <path
      d="M3.625 20.875C3.349 20.875 3.125 20.651 3.125 20.375V16.333C3.125 16.057 3.349 15.833 3.625 15.833C3.901 15.833 4.125 16.057 4.125 16.333V20.375C4.125 20.651 3.901 20.875 3.625 20.875Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'Expand');

export default Icon;
